export default "__VITE_ASSET__CMEhlH4X__"